import { createContext } from 'react';

const store = createContext(null);
export default store;
